'use client';

import { useEmbedScroll } from '../../../hooks/useEmbedScroll';

/**
 * Scroll the iFrame into view within the parent
 */
export const EmbedScroll = () => {
    useEmbedScroll();

    return null;
};
